import { isAuthenticated } from '@/modules/user/helpers/guards';
import Level4Category from './views/Level4Category.vue';
import Level4Product from './views/Level4Product.vue';
import Level4 from './views/Level4.vue';

const routes = [
  {
    path: '/level4',
    name: 'Catalog',
    component: Level4,
    beforeEnter: isAuthenticated,
    exact: true,
    meta: {
      navigation: true,
      breadcrumbs: [
        { text: 'Home', link: '/' },
        { text: 'Catalog', link: '/level4?id=0' },
      ],
    },
  },
  {
    path: '/level4/product/:product',
    name: 'Level4Product',
    component: Level4Product,
    beforeEnter: isAuthenticated,
    meta: {
      breadcrumbs: [
        { text: 'Home', link: '/' },
        { text: 'Catalog', link: '/level4' },
      ],
    },
  },
  {
    path: '/level4/category/:category',
    name: 'Level4Category',
    component: Level4Category,
    beforeEnter: isAuthenticated,
    meta: {
      breadcrumbs: [
        { text: 'Home', link: '/' },
        { text: 'Catalog', link: '/level4' },
      ],
    },
  },
];

export default routes;
